import { ColumnsType } from "antd/es/table";
import { ITicklerTypeExtended } from "../../../../types/Tickler";
import { useCallback, useMemo } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useButtonHandlers } from "./useButtonHandlers";
import { Row } from "antd";
import { TRequest } from "../types";

type TTableColumnsProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setId: React.Dispatch<React.SetStateAction<string | null>>;
  setRequest: React.Dispatch<React.SetStateAction<TRequest>>;
  reloadData: () => void;
  openSideBar: (id: string) => void;
};

export const useGetTableColumns = ({
  setIsOpen,
  setId,
  setRequest,
  reloadData,
  openSideBar,
}: TTableColumnsProps) => {
  const { onDeleteBtnClick } = useButtonHandlers({
    reloadData,
    setIsOpen,
    setId,
  });

  const onSortChange = useCallback(
    (sorter: any, request: any) => {
      const newRequest = { ...request };
      if (!sorter.order) {
        delete newRequest["order"];
      }

      if (sorter.field === "typeName") {
        newRequest["order"] = sorter.order === "ascend" ? 2 : 3;
      }

      setRequest(newRequest);
    },
    [setRequest]
  );

  const columns: ColumnsType<ITicklerTypeExtended> = useMemo(
    () => [
      {
        title: "Tickler Type Name",
        key: "type",
        dataIndex: "typeName",
        width: "30%",
        sorter: true,
      },
      {
        title: "Default Text",
        key: "text",
        dataIndex: "defaultText",
        width: "61%",
      },
      {
        key: "actions",
        width: "9%",
        render: (_: any, record: ITicklerTypeExtended) => {
          const { id } = record;

          return (
            <Row
              className="w-100 h-100 ant-table-actions"
              onClick={(e) => e.stopPropagation()}
            >
              <EditOutlined
                className="ant-table-btn logo-cursor"
                onClick={() => openSideBar(id)}
              />
              <DeleteOutlined
                className="ant-table-btn logo-cursor"
                onClick={() => onDeleteBtnClick(id)}
              />
            </Row>
          );
        },
      },
    ],
    [onDeleteBtnClick, openSideBar]
  );

  return { columns, onSortChange };
};
